let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("YreR5")).then(() => parcelRequire('20BFG'));